import u from "./ui.module.css";

export default function Field({
  label,
  hint,
  error,
  children,
  className = "",
}) {
  return (
    <div className={`${u.field} ${className}`}>
      {label ? <label className={u.label}>{label}</label> : null}
      {children}
      {hint && !error ? <span className={u.hint}>{hint}</span> : null}
      {error ? <span className={u.errorText}>{error}</span> : null}
    </div>
  );
}

export function CheckLabel({
  className = "",
  strong = false,
  children,
  ...rest
}) {
  return (
    <label
      className={`${u.checkLabel} ${strong ? u.checkLabelStrong : ""} ${className}`.trim()}
      {...rest}
    >
      {children}
    </label>
  );
}

export function Input({ error, className = "", type, ...rest }) {
  const isDateTime =
    type === "date" || type === "time" || type === "datetime-local";
  return (
    <input
      type={type}
      className={`${u.input} ${isDateTime ? u.dateTimeInput : ""} ${error ? u.inputError : ""} ${className}`.trim()}
      {...rest}
    />
  );
}

export function Select({ error, className = "", children, ...rest }) {
  return (
    <select
      className={`${u.select} ${error ? u.inputError : ""} ${className}`}
      {...rest}
    >
      {children}
    </select>
  );
}

export function Textarea({ error, className = "", ...rest }) {
  return (
    <textarea
      className={`${u.textarea} ${error ? u.inputError : ""} ${className}`}
      {...rest}
    />
  );
}
